import { FC } from 'react';

interface AvatarImageProps {
  alt: string;
  className: string;
  size: number;
  src: string;
  onError: () => void;
}

export const AvatarImage: FC<AvatarImageProps> = ({ alt, className, size, src, onError }) => {
  return (
    <img
      alt={alt}
      className={className}
      decoding="async"
      height={size}
      loading="lazy"
      onError={onError}
      src={src}
      width={size}
    />
  );
};
